import { Container, Heading } from '@chakra-ui/react';
import { useContext, useEffect, useState } from 'react';
import CommesseTable from './CommesseTable';
import AddCommessaModal from './AddCommessaModal';

import axios from 'axios'
import { useCompany } from '../../contexts/CompanyContext';
import AuthContext from '../../contexts/AuthContext';

const CommessePage = () => {

    const [commesse, setCommesse] = useState([]);
    const {selectedCompany} = useCompany();
    const {getToken} = useContext(AuthContext);

    useEffect(() => {
        retrieveCommesse();
    }, []);

    /** 
     * Method to retrieve the list of commesse from the endpoint
    */
    function retrieveCommesse() {
        axios.get(`/api/${selectedCompany['company_id']}/commesse`, {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                },
        }).then(response => {
            if(response.status === 200){
                setCommesse(response.data.commesse);
            }else{
                console.error("Error fetching commesse: " + response.data);
            }
        }).catch((error) => {
            console.error("Error fetching commesse");
        });
    }

    function handleNewCommessa(new_commessa) {
        let last_id = commesse[commesse.length - 1].id;

        new_commessa.id = last_id + 1;

        setCommesse((prevCommesse) => [...prevCommesse, new_commessa]);
    }

    return (
        <Container maxW="container.xl" py={8}>

            <Heading>Commesse</Heading>
            <AddCommessaModal onAssetAdded={handleNewCommessa}/>
            <CommesseTable commesse={commesse}/>

        </Container>
    );
};

export default CommessePage;